const Blockly = require('blockly');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');
const convertToBoolean = require('../../../../helpers/convertToBoolean');

const TOOLTIP = 'Force subsequent card list values onto a new line. Optionally display a horizontal separator line.';

function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    blocklyBlock.setTooltip(TOOLTIP);
    blocklyBlock.setInputsInline(false);
    line1OfInputs
        .appendField('  Include Line:')
        .appendField(new Blockly.FieldCheckbox('FALSE'), 'includeLine');
}

function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
    addCodeProperties([{ key: 'includeLine', handler: convertToBoolean }]);
    code.dataType = 'lineBreak';
    return code;
}

module.exports = { addBlockSpecificFields, convertCustomFieldsToCode };
